import { connect, useDispatch } from "react-redux";
import { Form } from "./styles";
import ModalAvatarEditor from "../../../../components/Form/AvatarEditor/components/ModalAvatar";
import { useForm } from "react-hook-form";
import { useEffect, useState, useRef, useMemo } from "react";
import { changeUserAvatar, resetChangeUserAvatar } from "../../../../store/actions/user";
import { useOnboardingModals } from "../../index";

const Component = ({ changeUserAvatarStates, userInformation }) => {
  const dispatch = useDispatch();
  const [profilePic, setProfilePic] = useState();
  const ref = useRef<HTMLFormElement>();
  const { nextModal } = useOnboardingModals();

  const onFormSubmit = (data) => {
    dispatch(changeUserAvatar({ ...data, userId: userInformation?.id }));
  };

  const onFormError = (data) => { };

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onSubmit",
  });

  useEffect(() => {
    if (userInformation?.profile_pic) {
      setProfilePic(userInformation?.profile_pic.url);
    }
  }, [userInformation]);

  useEffect(() => {
    if (changeUserAvatarStates.success) {
      // Llamar a nextModal después de un pequeño delay para que el modal se cierre
      setTimeout(() => {
        nextModal();
        dispatch(resetChangeUserAvatar());
      }, 2000);
    }
  }, [changeUserAvatarStates, dispatch, nextModal]);

  return (
    <Form
      onSubmit={handleSubmit(onFormSubmit, onFormError)}
      id="change-avatar"
      ref={ref}
      style={{ height: 0, width: 0 }}
    >
      <ModalAvatarEditor
        onSave={() => {
          ref.current?.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
        }}
        name="profile_pic"
        setValue={setValue}
        picture={profilePic}
        register={register}
        loading={changeUserAvatarStates.loading}
        errors={{ ...errors }}
      />
    </Form>
  );
};

const state = ({ userStore }) => {
  const { data: userInformation } = userStore.information;
  const { states: changeUserAvatarStates } = userStore.changeUserAvatar;
  return {
    userInformation,
    changeUserAvatarStates,
  };
};

export default connect(state)(Component);
